import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import android from "../assets/android-google.gif";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";
import mysql from "../assets/mysql.png";
import powerbi from "../assets/powerbi.jfif";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.svg";

import adidas from "../assets/adidas.png";
import amazon from "../assets/amazon.png";
import asus from "../assets/asus.png";
import bolt from "../assets/bolt.png";
import nb from "../assets/nb.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";
import vaakbhawna from "../assets/vaakbhawna.png";
import django from "../assets/django.png";
import pandas from "../assets/pandas.png";
import numpy from "../assets/numpy.png";
import kaggle from "../assets/kaggle.png";
import matplot from "../assets/matplot.jfif";

import tableau from "../assets/tableau.webp";
import scikit from "../assets/scikit.png";
import lnb from "../assets/lnb.png";
import jupyter from "../assets/jupyter.png";
import facerecognition from "../assets/facerecognition.png";
import saintmary from "../assets/saintmary.jfif";
import kushalvidya from "../assets/kushalvidya.jfif";
import saurabh from "../assets/saurabh.jfif";
import iiit from "../assets/iiit.png";
import hackmanthan from "../assets/hackmanthan.jfif";
import researcher from "../assets/researcher.jfif";
import ieeecertificate from "../assets/ieeecertificate.jfif";
import google from "../assets/google.jfif";
import ieee from "../assets/ieee.png";
import coursera from "../assets/coursera.jfif";
import construct from "../assets/construct.jfif";
import hackerrank from "../assets/hackerrank.jfif";
import skillup from "../assets/skillup.png";
import infographic from "../assets/infographic.jpeg";

export default {
  infographic,
  ieee,
  construct,
  skillup,
  hackerrank,
  coursera,
  google,
  saurabh,
  lnb,
  kaggle,
  matplot,
  numpy,
  scikit,
  tableau,
  jupyter,
  pandas,
  django,
  facerecognition,
  vaakbhawna,
  ieeecertificate,
  hackmanthan,
  researcher,
  iiit,
  kushalvidya,
  saintmary,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  android,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  mysql,
  powerbi,
};
